module.exports = __webpack_public_path__ + "assets/img/gd3.2877e9b2.jpg";